<button
  (click)="handleClick($event)"
  class="btn btn-lg btn-primary btn-block"
  type="submit"
  [disabled]="!valid || preloading"
>
  <i class="fa fa-cog a-spin" *ngIf="loading"></i>
  {{ loading ? "" : text }}
</button>
